module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious"
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "app-pairing__header app-pairing__header--spread"
  }, [_c('h1', {
    staticClass: "app-pairing__title title--general title--1"
  }, [_vm._v("Webkey Client required")])]), _vm._v(" "), _c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__section"
  }, [_c('p', {
    staticClass: "app-pairing__to-get-started"
  }, [_vm._v("To get started controlling your device with Webkey you have to download and install the Webkey client app")]), _vm._v(" "), _c('a', {
    staticClass: "app-pairing__link",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.webkey&utm_source=dashboard&utm_campaign=no-app-installed&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
    }
  }, [_c('img', {
    staticClass: "app-pairing__bitmap",
    attrs: {
      "alt": "Get it on Google Play",
      "src": "https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-732e898e","hasScoped":false}!./app/components/app-pairing/template.html
// module id = 363
// module chunks = 0